import axios from "axios"; 

const EmpAllocationService = {
  // Fetch all purchase orders
  async getAll(date) {
    try {
      const response = await axios.get(`/EmpAllocation/GetEmpAllocation?p_date=${date}`, {
        // const response = await axios.get(`http://localhost:51976/EmpAllocation/GetEmpAllocation?p_date=${date}`, {
        headers: {
          
        },
      });

      console.log("API response:", response.data);
      return Array.isArray(response.data.ResultSet) ? response.data.ResultSet : [];
    } catch (error) {
      console.error("Error fetching Employee ALlocation:", error);
      throw error;
    }
  },
}

export default EmpAllocationService;
